import { Pipe, PipeTransform } from '@angular/core';
/*
 * Capitalize the first letter of the string
 * Takes a string as a value.
 * Usage:
 *    value | ngxCapitalizeFirst
 *
 * Example:
 *     value.name = daniel
 *     {{ value.name | ngxCapitalizeFirst  }}
 *     formats to: Daniel
*/
@Pipe({
    name: 'ngxCapitalizeFirst'
})
export class TransformCapitalizeFirstPipe implements PipeTransform {
    transform(value: string): string {
        if (value === null) return 'Not assigned';

        return value.charAt(0).toUpperCase() + value.slice(1);
    }
}
